import { useRefundLineItems } from "@/pages/(app)/returns/refund/hooks/use-refund-line-items-context.tsx";
import useLineItemsState from "@/pages/(app)/returns/refund/hooks/use-line-items-state-context.tsx";

export function useRefundLineItemsContainADiscount() {
  const { items: draftLineItems } = useRefundLineItems();
  const { lineItemsState } = useLineItemsState();
  return draftLineItems.some((lineItem) => {
    const itemState = lineItemsState[lineItem.line_item_id];
    return (
      lineItem.resolution === "discount" && itemState.total.selectedQuantity > 0
    );
  });
}
